import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { CheckoutForm } from '../../components/checkout/CheckoutForm'
import { CheckoutLayout } from '../../components/checkout/CheckoutLayout'
import { api } from '../../core/trpc'

const checkoutSearchSchema = z.object({
    programId: z.string().optional(),
    eventId: z.string().optional(),
    eventPackageId: z.string().optional(),
    cancelled: z.string().optional(),
    error: z.string().optional(),
})

function CheckoutPage() {
    const { programId, eventId, eventPackageId, cancelled, error } = Route.useSearch()
    const [data] = api.webCheckout.getCheckoutItems.useSuspenseQuery({
        itemType: programId ? 'program' : eventId ? 'event' : undefined,
        itemId: programId ?? eventId,
    })

    return (
        <CheckoutLayout>
            <section className="relative overflow-hidden bg-off-white py-24">
                <div className="absolute -right-40 -top-40 h-96 w-96 rounded-full bg-brand-yellow/10 blur-[120px]" />
                <div className="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-primary/10 blur-[120px]" />

                <div className="relative mx-auto max-w-[800px] px-6">
                    <div className="mb-16 text-center">
                        <div className="mb-6 inline-block rounded-full bg-brand-yellow px-4 py-1 text-[10px] font-bold uppercase tracking-widest text-brand-dark">
                            Jelentkezés
                        </div>
                        <h1 className="mb-6 text-4xl font-bold leading-tight text-brand-dark md:text-6xl">
                            Jelentkezzen programjainkra
                            <br />
                            <span className="text-primary">és eseményeinkre</span>
                        </h1>
                        <p className="mx-auto max-w-xl text-lg leading-relaxed text-brand-gray">
                            Töltse ki az alábbi űrlapot, és hamarosan felvesszük Önnel a
                            kapcsolatot.
                        </p>
                    </div>
                </div>

                <div className="relative mx-auto max-w-[700px] px-6">
                    {cancelled && (
                        <div className="mb-6 rounded-2xl border border-amber-200 bg-amber-50 px-6 py-4 text-sm text-amber-800">
                            A fizetés megszakadt. Kérjük, próbálja újra.
                        </div>
                    )}

                    {error && (
                        <div className="mb-6 rounded-2xl border border-red-200 bg-red-50 px-6 py-4 text-sm text-red-800">
                            Hiba történt a fizetés során. Kérjük, próbálja újra.
                        </div>
                    )}

                    <CheckoutForm
                        data={data}
                        defaultProgramId={programId}
                        defaultEventId={eventId}
                        defaultEventPackageId={eventPackageId}
                    />
                </div>
            </section>
        </CheckoutLayout>
    )
}

export const Route = createFileRoute('/checkout/')({
    head: () => ({
        meta: [{ title: 'Long-Y - Fizetés' }],
    }),
    component: CheckoutPage,
    validateSearch: checkoutSearchSchema,
    loaderDeps: ({ search }) => ({
        programId: search.programId,
        eventId: search.eventId,
    }),
    loader: async ({ context, deps }) => {
        await context.apiUtils.webCheckout.getCheckoutItems.ensureData({
            itemType: deps.programId ? 'program' : deps.eventId ? 'event' : undefined,
            itemId: deps.programId ?? deps.eventId,
        })
    },
})
